<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.zencustomers" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				<a href="javascript:void(0)" routerLink="/zen-customers">ZEN Master Sites</a>
			</li>

			<li class="breadcrumb-item active" aria-current="page">
				Incidents
			</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<button type="button" class="btn btn-outline-secondary me-2" (click)="toggleFilters()">
				<fa-icon icon="filter" size="sm" ngbTooltip="Filter" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Filter</span> -->
			</button>

			<button type="button" class="btn btn-outline-secondary" (click)="loadIncidents()">
				<fa-icon icon="sync-alt" size="sm" [spin]="loading || refreshing" ngbTooltip="Refresh" placement="start">
				</fa-icon>
				<!-- <span class="cp-action-button-text">Refresh</span> -->
			</button>
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<!-- <div>states={{ states }}</div>
	<div>actions={{ actions }}</div> -->

	<form [formGroup]="theForm" *ngIf="showFilters">
		<div class="row ps-2 pe-2">
			<div class="cp-filter-block-3">
				<ng-select [items]="stateSelections" bindValue="value" bindLabel="label" id="states" formControlName="states"
					[multiple]="true" (change)="onFormChange()" placeholder="Filter by State">
				</ng-select>
			</div>

			<div class="cp-filter-block-3">
				<ng-select [items]="seSelections" bindValue="id" bindLabel="name" id="seIds" formControlName="seIds" [multiple]="true"
					(change)="onFormChange()" placeholder="Filter by SE">
				</ng-select>
			</div>

			<div class="cp-filter-block-3">
				<div class="input-group">
					<button class="btn btn-outline-secondary" (click)="d1.toggle()" type="button">
						<fa-icon icon="calendar-alt"></fa-icon>
					</button>
					<input class="form-control" placeholder="Not Before yyyy-mm-dd" id="notBefore" formControlName="notBefore"
						firstDayOfWeek="7" ngbDatepicker #d1="ngbDatepicker" (change)="onFormChange()" (dateSelect)="onFormChange()">
				</div>
			</div>

			<div class="cp-filter-block-3">
				<div class="input-group">
					<button class="btn btn-outline-secondary" (click)="d2.toggle()" type="button">
						<fa-icon icon="calendar-alt"></fa-icon>
					</button>

					<input class="form-control" placeholder="Not After yyyy-mm-dd" id="notAfter" formControlName="notAfter" ngbDatepicker
						firstDayOfWeek="7" #d2="ngbDatepicker" (change)="onFormChange()" (dateSelect)="onFormChange()">
				</div>
			</div>
		</div>
	</form>

	<div *ngIf="loading || refreshing" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<div *ngIf="maxMessage !== ''" class="cp-warning-message">{{ maxMessage }}</div>

	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>
		</thead>
		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow">
				<td class="cp-chopped-col-medium" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std"
					triggers="mouseenter:mouseleave" container="body">
					{{ item['__zenname'] }}
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{ item['__se'] }}
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{ item['__tam'] }}
				</td>
				<td class="cp-chopped-col-medium" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std"
					triggers="mouseenter:mouseleave" container="body">
					<a [href]="item['__url']" target="_blank">
						{{ item.name }}
					</a>
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{ item.state | titlecase}}
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{ item.start_time | date: ac.tableDateTimeFmt }}
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{ item['__duration_str'] }}
					<fa-icon *ngIf="item.end_time == null" icon="plus" size="sm" spin="true"></fa-icon>
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{item['__runtime_state'] }}
				</td>
				<td class="text-nowrap" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std" triggers="mouseenter:mouseleave"
					container="body">
					{{ item.likely_cause }}
				</td>
				<td class="cp-chopped-col-long-no-hover" [ngbPopover]="incidentPopover" popoverClass="cp-popover-std"
					triggers="mouseenter:mouseleave" container="body">
					{{ item.triggering_error_message }}
				</td>
				<td class="text-center">{{ item.num_objects }}</td>

				<ng-template #incidentPopover>
					<div class="cp-popover-banner">{{ item.name }}</div>
					<div class="cp-pre-text">{{
						incidentPopoverLines(item).join('\n')}}</div>
				</ng-template>

			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>
</div>